module.exports = __webpack_public_path__ + "img/avatar4.8ff63a48.jpg";